import { memo, useCallback } from 'react'
import { useRootContext } from '@/app/services/RootProvider/RootProvider'
import useAppData from '@/app/services/hooks/useAppData'
import Button from '@/components/core/Button/Button'
import FX from '@/components/core/FX/FX'
import Layout from '@/components/core/Layout/Layout'
import Logo from '@/components/elements/Logo/Logo'
import BurgerMenu from '../BurgerMenu/BurgerMenu'
import ButtonBurger from '../ButtonBurger/ButtonBurger'
import { useModalContext } from '../Modal/provider/ModalProvider'
import * as styles from './Header.module.scss'

/**
 * The `Header`
 * @returns {React.ReactElement} the element
 */
function Header () {
  const appData = useAppData()
  const { showModal } = useModalContext()
  const { isBurgerMenuOpen, setIsBurgerMenuOpen } = useRootContext()

  const handleToggle = useCallback(() => {
    setIsBurgerMenuOpen(prev => !prev)
  }, [])

  const handleClickSignUp = useCallback(() => {
    showModal({
      id: 'app:newsletter'
    })

    setIsBurgerMenuOpen(false)
  }, [])

  const handleClickBuyToken = useCallback(() => {
    showModal({
      id: 'app:buyersguide'
    })

    setIsBurgerMenuOpen(false)
  }, [])

  return (
    <>
      <Layout.Section Tag="header" className={styles.container}>
        <div className={styles.bar}>
          <div className={styles.left}>
            <FX.Switch isActive={true} className={styles.logo}>
              <FX.Wipe>
                <Logo />
              </FX.Wipe>
            </FX.Switch>
            <ButtonBurger onToggle={handleToggle} open={isBurgerMenuOpen} />
          </div>
          <div className={styles.menu}>
            <BurgerMenu isOpen={isBurgerMenuOpen} options={appData.links.header} />
          </div>
          <div className={styles.right}>
            <Button size="sm" onClick={handleClickSignUp}>Buy drink</Button>
           {/* <Button size="sm" onClick={handleClickBuyToken}>Buy Token</Button> */}
          </div>
        </div>
      </Layout.Section>
    </>
  )
}

export default memo(Header)
